module.exports = __webpack_public_path__ + "static/pic03-6c58e988d233629e5ef86e82cbfe46b8.jpg";